export default "__VITE_ASSET__BN034rk7__"